var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5V3ZM5 4L5.99589 3.90946C5.94907 3.39439 5.5172 3 5 3V4ZM21.99 7.14142C22.0681 6.59469 21.6882 6.08816 21.1414 6.01005C20.5947 5.93195 20.0882 6.31184 20.01 6.85858L21.99 7.14142ZM5.27273 7L4.27683 7.09054L5.27273 7ZM7.95668 14.8602L7.88543 13.8628L7.95668 14.8602ZM3 5H5V3H3V5ZM8.02793 15.8577L18.462 15.1124L18.3195 13.1175L7.88543 13.8628L8.02793 15.8577ZM21.2181 12.5443L21.99 7.14142L20.01 6.85858L19.2382 12.2614L21.2181 12.5443ZM4.00411 4.09054L4.27683 7.09054L6.26862 6.90946L5.99589 3.90946L4.00411 4.09054ZM4.27683 7.09054L4.82651 13.1369L6.81829 12.9559L6.26862 6.90946L4.27683 7.09054ZM18.462 15.1124C19.8707 15.0118 21.0184 13.9423 21.2181 12.5443L19.2382 12.2614C19.1716 12.7275 18.7891 13.0839 18.3195 13.1175L18.462 15.1124ZM7.88543 13.8628C7.34207 13.9016 6.86761 13.4984 6.81829 12.9559L4.82651 13.1369C4.97446 14.7644 6.39785 15.9741 8.02793 15.8577L7.88543 13.8628Z",
    fill: "#0761AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H15",
    stroke: "#0761AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 19.5,
    r: 1.5,
    fill: "#0761AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 19.5,
    r: 1.5,
    fill: "#0761AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4f471cbc.svg";
export { ForwardRef as ReactComponent };